import { openDB } from 'idb';

const createDatabase = async () => {
  try {
    const db = await openDB('FUTURISS', 3, {
      upgrade(db, oldVersion, newVersion, transaction) {
     //    console.log(`Upgrading database from version ${oldVersion} to ${newVersion}`);

        if (!db.objectStoreNames.contains('universities')) {
        //   console.log("Creating 'universities' store...");
          db.createObjectStore('universities', { keyPath: 'id', autoIncrement: true });
        }

        if (!db.objectStoreNames.contains('currentyears')) {
     //      console.log("Creating 'currentyears' store...");
          const currentyearsStore = db.createObjectStore('currentyears', { keyPath: 'id', autoIncrement: true });
          currentyearsStore.createIndex('universityIDICurrentYearndex', 'universityID');
        }

        if (!db.objectStoreNames.contains('faculties')) {
       //    console.log("Creating 'faculties' store...");
          const facultiesStore = db.createObjectStore('faculties', { keyPath: 'id', autoIncrement: true });
          facultiesStore.createIndex('universityIDIndex', 'universityID');
        }

        if (!db.objectStoreNames.contains('departments')) {
       //    console.log("Creating 'departments' store...");
          const departmentsStore = db.createObjectStore('departments', { keyPath: 'id', autoIncrement: true });
          departmentsStore.createIndex('combinedIDIndex', ['universityID', 'facultyID']);
        }

      },
    });

    return db;
  } catch (error) {
    console.error("Error setting up IndexedDB:", error);
    throw error; // Re-throw the error for further handling if needed
  }
};

export { createDatabase };